import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { HeaderComponent } from '../components/header/header.component';
import { SubheaderComponent } from '../components/subheader/subheader.component';
import { CustomValidators } from "../shared/validators/custom-validators";
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';

@Component({
  selector: 'app-business-data',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CheckboxModule, SidebarComponent, HeaderComponent, SubheaderComponent,DropdownModule,
    InputTextModule,
    ButtonModule],
  templateUrl: './business-data.component.html',
  styleUrls: ['./business-data.component.css']
})
export class BusinessDataComponent implements OnInit {
  businessDataForm!: FormGroup;
  businessAddressForm!: FormGroup;
  currentStep: string = 'business-data';

  // Opciones para dropdowns (datos laborales)
  educationOptions = [
    { label: 'Primaria', value: 'primaria' },
    { label: 'Secundaria', value: 'secundaria' },
    { label: 'Preparatoria', value: 'preparatoria' },
    { label: 'Técnico', value: 'tecnico' },
    { label: 'Licenciatura', value: 'licenciatura' },
    { label: 'Maestría', value: 'maestria' },
    { label: 'Doctorado', value: 'doctorado' }
  ];

  employmentStatusOptions = [
    { label: 'Empleado', value: 'empleado' },
    { label: 'Independiente', value: 'independiente' },
    { label: 'Empresario', value: 'empresario' },
    { label: 'Jubilado', value: 'jubilado' },
    { label: 'Estudiante', value: 'estudiante' }
  ];

  economicActivityOptions = [
    { label: 'Agricultura', value: 'agricultura' },
    { label: 'Comercio', value: 'comercio' },
    { label: 'Construcción', value: 'construccion' },
    { label: 'Educación', value: 'educacion' },
    { label: 'Finanzas', value: 'finanzas' },
    { label: 'Gobierno', value: 'gobierno' },
    { label: 'Salud', value: 'salud' },
    { label: 'Servicios', value: 'servicios' },
    { label: 'Tecnología', value: 'tecnologia' },
    { label: 'Transporte', value: 'transporte' },
    { label: 'Turismo', value: 'turismo' },
    { label: 'Otro', value: 'otro' }
  ];

  activitySpecificationOptions = [
    { label: 'Ventas', value: 'ventas' },
    { label: 'Administración', value: 'administracion' },
    { label: 'Operaciones', value: 'operaciones' },
    { label: 'Marketing', value: 'marketing' },
    { label: 'Recursos Humanos', value: 'recursos_humanos' },
    { label: 'Finanzas', value: 'finanzas' },
    { label: 'Tecnología', value: 'tecnologia' },
    { label: 'Otro', value: 'otro' }
  ];

  companyTypeOptions = [
    { label: 'Micro empresa', value: 'micro' },
    { label: 'Pequeña empresa', value: 'pequena' },
    { label: 'Mediana empresa', value: 'mediana' },
    { label: 'Gran empresa', value: 'grande' },
    { label: 'Gobierno', value: 'gobierno' },
    { label: 'ONG', value: 'ong' }
  ];

  incomeFrequencyOptions = [
    { label: 'Semanal', value: 'semanal' },
    { label: 'Quincenal', value: 'quincenal' },
    { label: 'Mensual', value: 'mensual' },
    { label: 'Bimestral', value: 'bimestral' },
    { label: 'Trimestral', value: 'trimestral' },
    { label: 'Anual', value: 'anual' }
  ];

  jobSeniorityOptions = [
    { label: 'Menos de 6 meses', value: 'menos_6_meses' },
    { label: '6 meses - 1 año', value: '6_meses_1_ano' },
    { label: '1 - 2 años', value: '1_2_anos' },
    { label: '2 - 5 años', value: '2_5_anos' },
    { label: '5 - 10 años', value: '5_10_anos' },
    { label: 'Más de 10 años', value: 'mas_10_anos' }
  ];

  economicDependentsOptions = [
    { label: 'Ninguno', value: '0' },
    { label: '1 dependiente', value: '1' },
    { label: '2 dependientes', value: '2' },
    { label: '3 dependientes', value: '3' },
    { label: '4 dependientes', value: '4' },
    { label: '5 o más dependientes', value: '5_mas' }
  ];

  immediateBossOptions = [
    { label: 'Sí, tengo jefe inmediato', value: 'si' },
    { label: 'No, soy independiente', value: 'no_independiente' },
    { label: 'No, soy el jefe', value: 'no_jefe' }
  ];

  // Opciones para dropdowns (domicilio de empresa)
  colonyOptions: any[] = [];
  municipalityOptions: any[] = [];

  constructor(
    private router: Router,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.initializeForms();
  }

  private initializeForms(): void {
    this.businessDataForm = this.fb.group({
      education: ['', Validators.required],
      employmentStatus: ['', Validators.required],
      economicActivity: ['', Validators.required],
      activitySpecification: [''],
      companyType: ['', Validators.required],
      secondaryActivity: [''],
      activityDescription: ['', [Validators.required, Validators.maxLength(200)]],
      incomeFrequency: ['', Validators.required],
      monthlyIncome: ['', [Validators.required, CustomValidators.minAmount(10000)]],
      monthlyExpenses: ['', [Validators.required, CustomValidators.minAmount(100)]],
      jobSeniority: ['', Validators.required],
      economicDependents: ['', Validators.required],
      companyPhone: ['', [Validators.required, CustomValidators.mexicanPhone]],
      extension: [''],
      immediateBoss: ['', Validators.required]
    });

    this.businessAddressForm = this.fb.group({
      sameAsPersonal: [false],
      street: [''],
      exteriorNumber: [''],
      interiorNumber: [''],
      postalCode: ['', [CustomValidators.postalCode]],
      colony: [''],
      municipality: [''],
      state: ['']
    });

    // Configurar validaciones condicionales para dirección
    this.setupConditionalValidations();
  }

  private setupConditionalValidations(): void {
    this.businessAddressForm.get('sameAsPersonal')?.valueChanges.subscribe(sameAsPersonal => {
      const addressFields = ['street', 'exteriorNumber', 'postalCode', 'colony', 'municipality'];
      
      if (sameAsPersonal) {
        // Remover validaciones cuando es el mismo domicilio
        addressFields.forEach(field => {
          this.businessAddressForm.get(field)?.clearValidators();
          this.businessAddressForm.get(field)?.setValue('');
        });
      } else {
        // Agregar validaciones cuando no es el mismo domicilio
        this.businessAddressForm.get('street')?.setValidators([Validators.required]);
        this.businessAddressForm.get('exteriorNumber')?.setValidators([Validators.required]);
        this.businessAddressForm.get('postalCode')?.setValidators([Validators.required, CustomValidators.postalCode]);
        this.businessAddressForm.get('colony')?.setValidators([Validators.required]);
        this.businessAddressForm.get('municipality')?.setValidators([Validators.required]);
      }
      
      addressFields.forEach(field => {
        this.businessAddressForm.get(field)?.updateValueAndValidity();
      });
    });

    // Configurar carga de colonias y municipios cuando cambia el código postal
    this.businessAddressForm.get('postalCode')?.valueChanges.subscribe(postalCode => {
      if (postalCode && postalCode.length === 5) {
        this.loadColoniesAndMunicipalities(postalCode);
      } else {
        this.colonyOptions = [];
        this.municipalityOptions = [];
        this.businessAddressForm.patchValue({
          colony: '',
          municipality: '',
          state: ''
        });
      }
    });
  }

  onSubmitBusinessData(): void {
    if (this.businessDataForm.valid) {
      console.log('Datos laborales:', this.businessDataForm.value);
      this.currentStep = 'business-address';
    } else {
      this.markFormGroupTouched(this.businessDataForm);
      console.log('Por favor completa todos los campos requeridos');
    }
  }

  onSubmitBusinessAddress(): void {
    if (this.businessAddressForm.valid) {
      console.log('Domicilio de empresa:', this.businessAddressForm.value);
      this.router.navigate(['/loan-use']);
    } else {
      this.markFormGroupTouched(this.businessAddressForm);
      console.log('Por favor completa todos los campos requeridos del domicilio');
    }
  }

  onSubmitFinalForm(): void {
    const businessDataValid = this.businessDataForm.valid;
    const businessAddressValid = this.businessAddressForm.valid;
    
    if (businessDataValid && businessAddressValid) {
      console.log('Datos laborales:', this.businessDataForm.value);
      console.log('Domicilio de empresa:', this.businessAddressForm.value);
      this.router.navigate(['/loan-use']);
    } else {
      this.markFormGroupTouched(this.businessDataForm);
      this.markFormGroupTouched(this.businessAddressForm);
      console.log('Por favor completa todos los campos requeridos');
    }
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      control?.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  // Método para formatear moneda
  formatCurrency(event: any, fieldName: string): void {
    let value = event.target.value.replace(/[^\d]/g, '');
    
    if (value) {
      const formatted = new Intl.NumberFormat('es-MX').format(parseInt(value));
      event.target.value = formatted;
      this.businessDataForm.patchValue({ [fieldName]: formatted });
    }
  }

  // Método para permitir solo números
  onlyNumbers(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    
    if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1 ||
        (charCode === 65 && event.ctrlKey === true) ||
        (charCode === 67 && event.ctrlKey === true) ||
        (charCode === 86 && event.ctrlKey === true) ||
        (charCode === 88 && event.ctrlKey === true)) {
      return;
    }
    
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  // Método para manejar el cambio de código postal
  onPostalCodeChange(event: any): void {
    const postalCode = event.target.value;
    
    if (postalCode.length === 5) {
      this.loadColoniesAndMunicipalities(postalCode);
    } else {
      this.colonyOptions = [];
      this.municipalityOptions = [];
      this.businessAddressForm.patchValue({
        colony: '',
        municipality: '',
        state: ''
      });
    }
  }

  // Método para cargar colonias y municipios
  loadColoniesAndMunicipalities(postalCode: string): void {
    this.colonyOptions = [
      { label: 'Centro', value: 'centro' },
      { label: 'Roma Norte', value: 'roma_norte' },
      { label: 'Condesa', value: 'condesa' },
      { label: 'Polanco', value: 'polanco' }
    ];
    
    this.municipalityOptions = [
      { label: 'Cuauhtémoc', value: 'cuauhtemoc' },
      { label: 'Miguel Hidalgo', value: 'miguel_hidalgo' },
      { label: 'Benito Juárez', value: 'benito_juarez' }
    ];
    
    this.businessAddressForm.patchValue({ state: 'Ciudad de México' });
  }

  // Métodos de validación para mostrar errores
  isFieldInvalid(formGroup: FormGroup, fieldName: string): boolean {
    const field = formGroup.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  getFieldError(formGroup: FormGroup, fieldName: string): string {
    const field = formGroup.get(fieldName);
    if (field && field.errors && (field.dirty || field.touched)) {
      if (field.errors['required']) return 'Este campo es requerido';
      if (field.errors['maxlength']) return `Máximo ${field.errors['maxlength'].requiredLength} caracteres`;
      if (field.errors['minAmount']) return 'El monto mínimo no es válido';
      if (field.errors['mexicanPhone']) return 'Número de teléfono inválido';
      if (field.errors['postalCode']) return 'Código postal inválido';
    }
    return '';
  }

  goBack(): void {
    this.router.navigate(['/address-personal']);
  }

  onSubmit(): void {
    console.log('Datos empresariales enviados');
    this.router.navigate(['/loan-use']);
  }
}
